import React from 'react'
import styled from 'styled-components'
import cn from 'clsx'

const LightboxElement = styled.div`
  background-color: ${props => props.theme.palette.neutral.default.one};
  height: 100%;
  display: grid;
  align-items: center;
`

interface Props extends React.PropsWithChildren {
  className?: string;
}

function LightBox(props:Props) {
  const {
    children,
    className,
  } = props

  return <LightboxElement className={cn(className)}>
    {children}
  </LightboxElement>
}

export default LightBox
